/**
 * HUB-E — Carte mouvement stock (DS Remobiles).
 */
import React from 'react';
import { ArrowRightLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import MagasinBadge from '../MagasinBadge';
import {
  formatMovementDate,
  MOTIF_LABELS,
  movementTypeMeta,
} from '../../utils/stock/stockDisplay';

export default function ActiviteStockMovementCard({ movement, testIdPrefix = 'activite-stock' }) {
  const type = movementTypeMeta(movement);
  const isTransfer = movement.type_mouvement === 'transfert';

  return (
    <article
      className="rounded-xl border p-4"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-movement-${movement.id}`}
    >
      <div className="flex flex-wrap items-start justify-between gap-2 mb-2">
        <div className="min-w-0">
          <Link
            to={movement.article_id ? `/stock/modifier/${movement.article_id}` : `/stock`}
            className="font-semibold text-[var(--rm-white)] hover:text-[var(--rm-red-light)] text-sm"
            data-testid={`${testIdPrefix}-movement-link-${movement.reference}`}
          >
            {movement.designation || movement.reference}
          </Link>
          <p className="text-xs font-mono text-[var(--rm-gray-500)] mt-0.5">{movement.reference}</p>
        </div>
        <span className={type.badge}>{type.label}</span>
      </div>

      <div className="flex flex-wrap items-center gap-2 mb-2">
        {isTransfer ? (
          <span className="inline-flex items-center gap-1.5 text-xs">
            <MagasinBadge code={movement.from_magasin_id || 'M1'} size="sm" />
            <ArrowRightLeft className="w-3 h-3 text-[var(--rm-gray-500)]" />
            <MagasinBadge code={movement.to_magasin_id || 'M2'} size="sm" />
          </span>
        ) : (
          <MagasinBadge code={movement.magasin_id || 'M1'} size="sm" />
        )}
        <span className="text-xs text-[var(--rm-gray-500)]">
          {MOTIF_LABELS[movement.motif] || movement.motif || '—'}
        </span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-sm">
        <div>
          <span className="text-[var(--rm-gray-500)]">Qté </span>
          <span className="font-bold text-[var(--rm-white)]">{movement.quantite}</span>
        </div>
        <div>
          <span className="text-[var(--rm-gray-500)]">Par </span>
          <span className="text-[var(--rm-gray-300)]">{movement.admin_username || '—'}</span>
        </div>
        <div className="col-span-2 sm:col-span-2">
          <span className="text-[var(--rm-gray-500)]">Date </span>
          <span className="text-[var(--rm-gray-300)]">{formatMovementDate(movement.created_at)}</span>
        </div>
      </div>
    </article>
  );
}
